module.exports = __webpack_public_path__ + "img/IMG-20200226-WA0049.66d5a716.jpg";